module.exports = __webpack_public_path__ + "static/qr-section-a338efd9d66d55b162d92c9226b21602.svg";